import moment from "moment";
import { useEffect, useState } from "react";
import { getDays } from "utils/constant";
import { useReport } from "utils/reports";
import LeadGenerated from "./lead-generated";

export default function DailyStats({ start, end, params = {} }) {
  const { report, isLoading, isError } = useReport(start, end, {
    ...params,
    type: "daily",
  });

  const [labels, setLabels] = useState([]);
  const [datasets, setDatasets] = useState({
    opens: [],
    interactions: [],
    impressions: [],
  });

  useEffect(() => {
    const labels = getDays(moment.unix(start), moment.unix(end));

    if (report && !isLoading) {
      setLabels(labels);
      let opens = [];
      let interactions = [];
      let impressions = [];
      labels.forEach((value) => {
        let payload = {
          opens: 0,
          interactions: 0,
          impressions: 0,
        };
        Object.entries(report).forEach(([date, data]) => {
          let rec = moment(new Date(date)).format("MM/DD");
          if (value === rec) {
            payload.opens = data?.clicks;
            payload.interactions = data?.interactions;
            payload.impressions = data?.opens;
          }
        });
        opens.push(payload.opens);
        interactions.push(payload.interactions);
        impressions.push(payload.impressions);
      });
      setDatasets({
        opens: opens,
        interactions: interactions,
        impressions: impressions,
      });
    } else {
      const values = labels.map(() => {
        return 0;
      });
      setLabels(labels);
      setDatasets({
        opens: values,
        interactions: values,
        impressions: values,
      });
    }
  }, [start, end, report, isLoading]);

  return isError ? (
    <p>Failed to load report.</p>
  ) : (
    <LeadGenerated labels={labels} datasets={datasets} loading={isLoading} />
  );
}
